// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { PublicationMap } from "./PublicationMap";
import {
  PublicationMapFromJSON,
  PublicationMapFromJSONTyped,
  PublicationMapToJSON,
  PublicationMapToJSONTyped,
} from "./PublicationMap";
import type { PublicationVersionFileReference } from "./PublicationVersionFileReference";
import {
  PublicationVersionFileReferenceFromJSON,
  PublicationVersionFileReferenceFromJSONTyped,
  PublicationVersionFileReferenceToJSON,
  PublicationVersionFileReferenceToJSONTyped,
} from "./PublicationVersionFileReference";

/**
 *
 * @export
 * @interface PublicationVersionRead
 */
export interface PublicationVersionRead {
  /**
   * A composite of publication_id and version, e.g. 'publication123:1'
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  version: number;
  /**
   *
   */
  files?: Array<PublicationVersionFileReference>;
  /**
   *
   */
  fileDescriptors?: Array<string>;
  /**
   *
   */
  maps?: Array<PublicationMap>;
  /**
   *
   */
  creator: User;
}

/**
 * Check if a given object implements the PublicationVersionRead interface.
 */
export function instanceOfPublicationVersionRead(value: object): value is PublicationVersionRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("publicationId" in (value as Record<string, any>)) &&
      !("publication_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["publicationId"] === undefined &&
      (value as Record<string, any>)["publication_id"] === undefined)
  )
    return false;
  if (!("version" in value) || value["version"] === undefined) return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  return true;
}

export function PublicationVersionReadFromJSON(json: any): PublicationVersionRead {
  return PublicationVersionReadFromJSONTyped(json, false);
}

export function PublicationVersionReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    publicationId: json["publication_id"],
    version: json["version"],
    files:
      json["files"] == null
        ? undefined
        : (json["files"] as Array<any>).map(PublicationVersionFileReferenceFromJSON),
    fileDescriptors: json["file_descriptors"] == null ? undefined : json["file_descriptors"],
    maps:
      json["maps"] == null ? undefined : (json["maps"] as Array<any>).map(PublicationMapFromJSON),
    creator: UserFromJSON(json["creator"]),
  };
}

export function PublicationVersionReadToJSON(json: any): PublicationVersionRead {
  return PublicationVersionReadToJSONTyped(json, false);
}

export function PublicationVersionReadToJSONTyped(
  value?: PublicationVersionRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    publication_id: value["publicationId"],
    version: value["version"],
    files:
      value["files"] == null
        ? undefined
        : (value["files"] as Array<any>).map(PublicationVersionFileReferenceToJSON),
    file_descriptors: value["fileDescriptors"],
    maps:
      value["maps"] == null ? undefined : (value["maps"] as Array<any>).map(PublicationMapToJSON),
    creator: UserToJSON(value["creator"]),
  };
}
